import React from "react";

export function Contact({ texts }: any) {
  return (
    <section
      id="contact"
      className="bg-[#F7F7F7] lg:py-44 py-20 flex items-center"
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap -mx-4">
          <div className="w-full lg:w-1/2 xl:w-1/2 px-4 mb-8 lg:mb-0 text-right">
            <h5 className="text-lg text-[#e04f39] uppercase mb-4">
              {texts.title}{" "}
            </h5>

            {texts.subtitle}
            <p className="text-lg font-light text-gray-600 mb-8">
              {texts.description}
            </p>
          </div>
          <div className="w-full lg:w-1/2 xl:w-1/2 px-4 mb-8 lg:mb-0">
            <form className="w-full">
              <div className="flex flex-wrap -mx-4 mb-4">
                <div className="w-full px-4 mb-4 lg:mb-0">
                  <input
                    type="text"
                    className="w-full p-4 text-lg border border-gray-300 rounded"
                    placeholder={texts.inputs[0]}
                    name="nome"
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-4 mb-4">
                <div className="w-full lg:w-1/2 xl:w-1/2 px-4 mb-4 lg:mb-0">
                  <input
                    type="email"
                    className="w-full p-4 text-lg border border-gray-300 rounded"
                    placeholder={texts.inputs[1]}
                    name="email"
                  />
                </div>
                <div className="w-full lg:w-1/2 xl:w-1/2 px-4 mb-4 lg:mb-0">
                  <input
                    type="text"
                    className="w-full p-4 text-lg border border-gray-300 rounded"
                    placeholder={texts.inputs[2]}
                    name="telefone"
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-4 mb-10">
                <div className="w-full px-4 mb-4 lg:mb-0">
                  <textarea
                    className="w-full p-4 text-lg border border-gray-300 rounded resize-none h-44"
                    placeholder={texts.inputs[3]}
                    name="mensagem"
                  ></textarea>
                </div>
              </div>
              <a
                href="#sobre"
                className="bg-[#e04f39] hover:[#e68475] text-white font-bold py-5 px-10 mt-14"
              >
                {texts.button}
              </a>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
